import { ScaleProvider, Theme, ThemeSyncWithSystemProvider } from '@qodana/blocks'
import { DEFAULT_SCALE_FACTOR } from '@qodana/blocks/lib/config'
import type { PropsWithChildren } from 'react'

import { StorageUnits } from './config/localStorage'
import type { UserConfiguration } from './types/user'
import { getFromLocalStorage, saveToLocalStorage } from './utils/localStorage'

type AppearanceProps = PropsWithChildren

export const Appearance = (props: AppearanceProps) => {
	const { children } = props
	const userConfig = getFromLocalStorage<UserConfiguration>(StorageUnits.USER_CONFIGURATION)

	const getTheme = () => {
		const storageValue = getFromLocalStorage<string>(StorageUnits.THEME)

		if (storageValue !== null && Object.values(Theme).includes(storageValue as Theme)) {
			return storageValue as Theme
		}

		const configTheme = userConfig?.theme
		if (configTheme && Object.values(Theme).includes(configTheme as Theme)) {
			return configTheme as Theme
		}

		return undefined
	}

	const saveTheme = (theme: Theme) => saveToLocalStorage(StorageUnits.THEME, theme)

	const initialScaleFactor = Number.isFinite(userConfig?.scaleFactor)
		? userConfig?.scaleFactor
		: DEFAULT_SCALE_FACTOR

	return (
		<ThemeSyncWithSystemProvider getTheme={getTheme} saveTheme={saveTheme}>
			<ScaleProvider initialScaleFactor={initialScaleFactor}>{children}</ScaleProvider>
		</ThemeSyncWithSystemProvider>
	)
}
